// extracted by mini-css-extract-plugin
module.exports = {"follow-btn":"follow-button_follow-btn__Xvny0","active":"follow-button_active__8Ns_k"};